import moment from "moment";

export const TYPE_ACCENT = {
  quote: "#3b82f6",
  contract: "#8b5cf6",
  visit: "#14b8a6",
  invoice: "#f59e0b",
};

export const DOT_OK = "#10b981";
export const DOT_WARN = "#f59e0b";
export const DOT_BAD = "#ef4444";
export const DOT_IDLE = "#94a3b8";

export const CHIP_BG = "#ffffff";

export function buildStyle(type, dot) {
  return {
    accent: TYPE_ACCENT[type],
    dot,
    backgroundColor: CHIP_BG,
    borderColor: TYPE_ACCENT[type],
    textColor: "#1f2937",
  };
}

export function getInvoiceColors(status) {
  const s = (status || "").toLowerCase();
  return buildStyle("invoice", s === "paid" ? DOT_OK : DOT_BAD);
}

export function getContractColors(status) {
  const s = (status || "").toLowerCase();
  let dot = DOT_IDLE;
  if (s === "converted" || s === "upcoming" || s === "today") dot = DOT_OK;
  else if (s === "scheduled") dot = DOT_WARN;
  else if (s === "unscheduled") dot = DOT_BAD;
  return buildStyle("contract", dot);
}

export function getQuoteColors(status) {
  const s = (status || "").toLowerCase();
  let dot = DOT_IDLE;
  if (s === "approved") dot = DOT_OK;
  else if (s === "awaiting response") dot = DOT_WARN;
  return buildStyle("quote", dot);
}

export function getVisitColors(visit) {
  const status = (visit?.Status || "").toLowerCase();
  const isCompleted =
    status === "completed" || status === "complete" || visit?.IsComplete === true;
  const isConfirmed =
    status === "confirmed" ||
    visit?.IsConfirm === true ||
    visit?.IsConfirmByWorker === true;
  const isLate = status === "late";
  const isToday =
    visit?.StartDate && moment(visit.StartDate).isSame(moment(), "day");

  let dot = DOT_IDLE;
  if (isCompleted) dot = DOT_OK;
  else if (isLate) dot = DOT_BAD;
  else if (isToday) dot = DOT_WARN;
  else if (isConfirmed) dot = DOT_OK;
  return buildStyle("visit", dot);
}
